"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _colors = require("HubStyleTokens/colors");

var _classnames = _interopRequireDefault(require("classnames"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var propTypes = {
  children: _propTypes.default.node.isRequired,
  className: _propTypes.default.string,
  showEditOverlay: _propTypes.default.bool.isRequired,
  onMouseEnter: _propTypes.default.func,
  onMouseLeave: _propTypes.default.func,
  onToggleEditBody: _propTypes.default.func
};
var defaultProps = {
  onMouseEnter: _emptyFunction.default,
  onMouseLeave: _emptyFunction.default,
  onToggleEditBody: _emptyFunction.default
};

var TimelineEditableSection =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineEditableSection, _PureComponent);

  function TimelineEditableSection() {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineEditableSection);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineEditableSection).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isHovering: false
    };
    return _this;
  }

  (0, _createClass2.default)(TimelineEditableSection, [{
    key: "handleMouseEnter",
    value: function handleMouseEnter() {
      this.setState({
        isHovering: true
      });
      this.props.onMouseEnter();
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave() {
      this.setState({
        isHovering: false
      });
      this.props.onMouseLeave();
    }
  }, {
    key: "getShouldShowOverlay",
    value: function getShouldShowOverlay() {
      return this.props.showEditOverlay && this.state.isHovering;
    }
  }, {
    key: "getIconClasses",
    value: function getIconClasses() {
      return (0, _classnames.default)('p-right-2', 'p-bottom-2', 'pointer', {
        'editable-section-icon': this.getShouldShowOverlay(),
        hidden: !this.getShouldShowOverlay()
      });
    }
  }, {
    key: "getSectionClass",
    value: function getSectionClass() {
      return (0, _classnames.default)(this.props.className, {
        'editable-section': this.getShouldShowOverlay()
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          onToggleEditBody = _this$props.onToggleEditBody;
      return _react.default.createElement(_UISection.default, {
        className: this.getSectionClass(),
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        "data-selenium-test": "timeline-editable-section"
      }, _react.default.createElement(_UIIcon.default, {
        name: "edit",
        className: this.getIconClasses(),
        color: _colors.CALYPSO_DARK,
        onClick: onToggleEditBody
      }), children);
    }
  }]);
  return TimelineEditableSection;
}(_PureComponent2.default);

TimelineEditableSection.propTypes = propTypes;
TimelineEditableSection.defaultProps = defaultProps;
var _default = TimelineEditableSection;
exports.default = _default;
module.exports = exports.default;